exports.WARNING_RED = "#f75d70";
exports.PRIMARY_BLUE = "#5C88D3";
exports.TEXT1 = "#202020";
exports.GREEN = "#80DDCD";
exports.WHITE = "#FFFFFF";
exports.GOLD = "#FEEFB3";
exports.BLACK = "#000";
exports.MAIN_BLUE = "#5D87D3";
exports.DARK_BLUE = "#02274B";
exports.GREEN_DARK3 = "#0e9384";

exports.PRIMARY_25 = "#F5FAFF";
exports.PRIMARY_50 = "#EFF8FF";
exports.PRIMARY_100 = "#D1E9FF";
exports.PRIMARY_700 = "#175CD3";
exports.PRIMARY_400 = "#53B1FD";
exports.PRIMARY_800 = "#1849A9";
exports.PRIMARY_600 = "#1570EF";

exports.GRAY = "#64666C";
exports.GRAY_50 = "#F9FAFB";
exports.GRAY_100 = "#F2F4F7";
exports.GRAY_300 = "#D0D5DD";
exports.GRAY_400 = "#98A2B3";
exports.GRAY_500 = "#667085";
exports.GRAY_700 = "#344054";
exports.GRAY_800 = "#1D2939";
exports.GRAY_900 = "#101828";
exports.GRAY5 = "#E0E0E0";
exports.GRAY_PLACEHOLDER = "#979797";
exports.SOFT_BLUE = "#6F92DC";
exports.DEEP_SLATE = "#1018280d";
